import { useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

const getSiteDataApi = async (): Promise<any> => {
  const response = await httpClient.get('api/site/site-data', {});
  return response.data;
};

const getPublicDataApi = async (): Promise<any> => {
  const response = await httpClient.get('api/site/public', {});
  return response.data;
};

export const useSiteData = () => {
  return useQuery({
    queryKey: ['site-data'],
    queryFn: getSiteDataApi,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const usePublicData = () => {
  return useQuery({
    queryKey: ['public-data'],
    queryFn: getPublicDataApi,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
